import { render, staticRenderFns } from "./projectedit.vue?vue&type=template&id=3002bcc2"
import script from "./projectedit.vue?vue&type=script&lang=js"
export * from "./projectedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports